import React from "react";
import { css } from "styled-system/css";
import type { SystemStyleObject } from "styled-system/types";
import { root, header, body, footer, interactive } from "./card.styles";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  css?: SystemStyleObject;
  isInteractive?: boolean;
}

export const Card = ({
  children,
  className: classNameProp,
  isInteractive = false,
  css: cssProp,
  ...props
}: CardProps) => {
  const generatedClassName = css(root, isInteractive && interactive, cssProp);

  const classes = classNameProp ? `${generatedClassName} ${classNameProp}` : generatedClassName;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

interface CardSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  css?: SystemStyleObject;
}

export const CardHeader = ({
  children,
  className: classNameProp,
  css: cssProp,
  ...props
}: CardSectionProps) => {
  const generatedClassName = css(header, cssProp);
  const classes = classNameProp ? `${generatedClassName} ${classNameProp}` : generatedClassName;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export const CardBody = ({
  children,
  className: classNameProp,
  css: cssProp,
  ...props
}: CardSectionProps) => {
  const generatedClassName = css(body, cssProp);
  const classes = classNameProp ? `${generatedClassName} ${classNameProp}` : generatedClassName;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export const CardFooter = ({
  children,
  className: classNameProp,
  css: cssProp,
  ...props
}: CardSectionProps) => {
  const generatedClassName = css(footer, cssProp);
  const classes = classNameProp ? `${generatedClassName} ${classNameProp}` : generatedClassName;

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

// Compound components
Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
